module.exports = __webpack_public_path__ + "static/img/huihua.82dd6478.png";